<template>
    <div>
        <br>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
<!--                <date-picker v-model="search.date"-->
<!--                             range-->
<!--                             placeholder="วันที่เริ่มต้น - วันที่สิ้นสุด"-->
<!--                             :format="changeFormat"-->
<!--                             :lang="lang" confirm>-->
<!--                </date-picker>-->
<!--                &nbsp;-->
<!--                <button type="button" class="btn btn-success" @click="getDriverTransportReportTable">-->
<!--                    <icon name="search"></icon>-->
<!--                    ค้นหา-->
<!--                </button>-->
                &nbsp;
                <button type="button" class="btn btn-primary" @click="addBonusModal">
                    <icon name="plus"></icon>
                    เพิ่มเรทโบนัส
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ชื่อ</th>
                    <th scope="col">ขั้นต่ำ</th>
                    <th scope="col">สูงสุด</th>
                    <th scope="col">โบนัส</th>
                    <th scope="col">ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in rateBonusList">
                    <td>{{data.name}}</td>
                    <td>{{data.minimum}}</td>
                    <td>{{data.maximum}}</td>
                    <td>{{data.rate}}</td>
                    <td>
<!--                        <a @click="showAccountDetailsModal(detail.id,data.id)">-->
<!--                            <icon name="pencil-alt"></icon>-->
<!--                        </a> &nbsp;&nbsp;-->
                        <a @click="deleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <b-modal hide-header hide-footer size="lg" ref="add_bonus">
            <div style="text-align: center;">
                <h4>ตั้งค่าโบนัสคนขับรถใหญ่</h4>
                <br />
                <div class="row">
                    <div class="col-3">
                        <label class="text-right">ชื่อรายการ</label>
                    </div>
                    <div class="col-9">
                        <input v-model="form.name"
                               type="text"
                               class="form-control"
                        />
                    </div>
                </div>
                <label></label>
                <div class="row">
                    <div class="col-3">
                        <label class="text-right">จำนวนค่าเที่ยว</label>
                    </div>
                    <div class="col-3">
                        <input v-model="form.minimum"
                               type="number"
                               class="form-control"
                               placeholder="เที่ยวเริ่มต้น"
                        />
                    </div>
                    <div class="col-3">
                        <input v-model="form.maximum"
                               type="number"
                               class="form-control"
                               placeholder="เที่ยวสิ้นสุด"
                        />
                    </div>
                    <div class="col-3">
                        <input v-model="form.rate"
                               type="number"
                               class="form-control"
                               placeholder="เงินโบนัส"
                        />
                    </div>
                </div>
                <br/>
                <div class="row justify-content-center">
                    <button class="btn btn-success" @click="addBonus">บันทึก</button>
                    &nbsp;
                    &nbsp;
                    &nbsp;
                    <button class="btn btn-secondary" @click="hideModal">ยกเลิก</button>
                </div>
            </div>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button
                    type="button"
                    class="btn btn-success"
                    @click="deleteBonus">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button
                    type="button"
                    class="btn btn-outline-secondary"
                    @click="hidedeleteModal">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import {domain} from "../../../util/Constants";
    import {mapState} from "vuex";

    export default {
        name: "DriverBonusRateList",
        components: {},
        data(){
          return{
                form:{
                    name:'',
                    minimum:'',
                    maximum:'',
                    rate:'',
                },
              delete_id : ''
          }
        },
        computed:{
            ...mapState({
                rateBonusList :state=>{
                    return state.DriverConfigBonus.rateBonusDriverLists;
                },
            }),
        },
        created() {
            this.$store.dispatch("DriverConfigBonus/setDriverBonus")
        },
        methods:{
            addBonusModal(){
                this.$refs.add_bonus.show();
            },
            hideModal(){
                this.$refs.add_bonus.hide();
            },
            deleteModal(id){
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hidedeleteModal(){
                this.$refs.delete_item.hide();
            },
            addBonus(){
                this.$store.dispatch('DriverConfigBonus/save',{id:null,data:this.form}).then(()=>{
                    this.form = {
                        name:'',
                        minimum:'',
                        maximum:'',
                        rate:'',
                    };
                    this.setTable();
                    this.hideModal();
                })
            },
            deleteBonus(){
                this.$store.dispatch('DriverConfigBonus/delete',this.delete_id).then(()=>{
                    this.setTable();
                    this.hidedeleteModal();
                    this.delete_id = '';
                });
            },
            setTable(){
                this.$store.dispatch("DriverConfigBonus/setDriverBonus")
            }
        }
    }
</script>

<style scoped>

</style>
